import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeComponentCtaLinkSkeleton } from './TypeComponentCtaLink'

export interface TypeHeaderCardLinkFields {
  internalName: EntryFieldTypes.Symbol
  link: EntryFieldTypes.EntryLink<TypeComponentCtaLinkSkeleton>
  description?: EntryFieldTypes.Text
  shortDescription?: EntryFieldTypes.Text
  displayNewTag?: EntryFieldTypes.Boolean
}

export type TypeHeaderCardLinkSkeleton = EntrySkeletonType<TypeHeaderCardLinkFields, 'headerCardLink'>
export type TypeHeaderCardLink<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeHeaderCardLinkSkeleton,
  Modifiers,
  Locales
>

export function isTypeHeaderCardLink<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeHeaderCardLink<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'headerCardLink'
}
